"use client"
import React, { useContext, useEffect, useRef, useState } from 'react';
import _ from 'lodash';
import { ContextData, FloatValues, cn, filterProducts, storeAssigned, getCurrencySign } from '@/services/Methods/normalMethods';
import withProductHOC from '@/HOC/withProductHOC';
import ButtonComponent from '@/Inputs/ButtonComponent';
import { notFoundImage } from '@/assets/images';
import Image from 'next/image';
import DistributorSingleProductPopUp from '@/components/ProductPage/DistributorSingleProductPopUp';
import { usePathname, useRouter } from 'next/navigation';
import ReactpaginateComp from '@/comman/ReactPaginateComp';
import { Search } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';


const AllProductPageComp = ({
    section = "normal",
    loading,
    onetime = true,
    _handleProductAdd,
    _quantityIncOrDec,
    allProductState, selectedCategory, setSelectedCategory,
    _addToCartFunction, _frequancyChange, isLearnMore, CATEGORIES, _checkoutQuantityIncDec, activeStep = "", setActiveStep,
    offset, totalCount, _onPaginationChange, _minCartQuantityIncDec, _getPorductAccordingSection, searchText, setSearchText, sortOrder, setSortOrder
}) => {
    const router = useRouter();
    const allData = useContext(ContextData);
    const [productOpen, setProductOpen] = useState(null);

    const cartProducts = allData?.addToCartProducts['normalProducts'] || [];
    const pathname = usePathname();

    return (
        <>
            <div className={(section === 'normal' && typeof (activeStep) === 'string') ? "pt-[37px] pb-[27px]" : ""}>
                <div className={(section === 'normal' && typeof (activeStep) === 'string') ? "wrp_div min-h-[350px] container px-[15px] xl:max-w-[1140px] lg:max-w-[990px] mx-auto" : ""}>

                    <div className="container 3xl:max-w-[1733px] px-[15px] mx-auto">
                        <ul className='flex flex-wrap gap-[30px]'>
                            <li className='block relative after:content-[""] after:h-[8px] after:w-[8px] after:rotate-[45deg] after:border-t-[1px] after:border-r-[1px] after:border-[#000] after:absolute after:top-[6px] after:-right-[16px]'>
                                <a href={`/${storeAssigned()}/`} className='block text-[14px] leading-[1.4] font-light'>Home</a>
                            </li>
                            <li className='block'>
                                <p className='block text-[14px] leading-[1.4] font-light'>{storeAssigned() === 'us' ? "all products" : "All Products"}</p>
                            </li>
                        </ul>
                    </div>
                    <div className="w-full mb-6">
                        <h2 className="text-black flex items-center justify-center xl:text-[48px] md:text-[40px] text-[30px] mt-4">
                            {CATEGORIES.map((data, index) => {
                                // console.log("dataaaaaaaaaaaaaaaaaaaaaaaaa", data);
                                return selectedCategory === data?.id && data?.name?.replace('_', ' ')

                            })}
                            {selectedCategory === null && "All Products"}
                        </h2>
                    </div>
                    {(typeof (activeStep) !== 'string' && cartProducts?.length > 0) && (
                        <div className='w-full mt-4 mb-6 justify-center flex gap-x-[20px] ' id="top-button">
                            <ButtonComponent id="go_next" onClick={() => setActiveStep(activeStep + 1)} classes=" w-auto block px-[18px] py-[10px] rounded-[6px] text-white text-[18px] leading-[1.1] font-normal transition-all duration-300 ease-in-out "> Checkout </ButtonComponent>
                        </div>
                    )}
                    <div className={`flex ${(section === 'normal') ? 'lg:flex-nowrap' : 'lg:flex-nowrap'} flex-wrap w-full items-start`}>
                        <div className="lg:w-[200px] w-full">
                            <h2 className="text-xl tracking-wider f-q-extrabold mb-4 lg:text-left text-center">
                                Shop By Category
                            </h2>
                            <div className="div_n flex flex-wrap lg:flex-col lg:justify-start justify-center gap-2 lg:max-w-full max-w-[225px] mx-auto">
                                {CATEGORIES?.map((data, index) => (
                                    <p
                                        onClick={() => {
                                            if (pathname === `/${storeAssigned()}/products`) {
                                                if (selectedCategory !== data?.id) {
                                                    setSearchText('');
                                                    setSortOrder('sort');
                                                    router.push(`/${storeAssigned()}/products?itemId=${data.id}`);
                                                }
                                            } else {
                                                setSearchText('');
                                                setSelectedCategory(data?.id);
                                                setSortOrder('sort');
                                            }
                                        }}
                                        className={`lg:w-full w-full px-[20px] rounded-[0px] border-[2px] border-[#eeeeee] bg-[#eeeeee] text-[#000000] py-[6px] cursor-pointer hover:text-primary transition-all duration-200 text-base font-medium hover:bg-[#000000] hover:border-[#000000] hover:text-[#ffffff] text-center xl:tracking-[1px] lg:tracking-[0.5px] uppercase
                                        ${(selectedCategory === +data?.id)
                                                ? " !bg-[#000000] !border-[#000000] !text-[#ffffff]"
                                                : " text-[#000] "
                                            }`}
                                        key={index}
                                    >
                                        {data?.name?.replace('_', ' ')}
                                    </p>
                                ))}
                            </div>
                        </div>
                        <div className={(section === 'normal' && typeof (activeStep) === 'string') ? "lg:w-[calc(100%-200px-20px)] w-full ml-auto lg:mt-[0] mt-6 flex  flex-wrap  items-start" : "xl:w-[calc(100%-200px-20px)] lg:w-[calc(100%-200px-15px)] w-full ml-auto lg:mt-[0] mt-6"}>
                            <div className='lg:mb-5 mb-4 relative text-center search-box'>

                                <div className={`flex justify-center relative w-full mx-auto`}>
                                    <button type="submit"
                                        className={` h-full sm:w-[30px] w-[24px] absolute top-0 lg:left-[10px] sm:left-[5px] left-[2px] pointer-events-none`}
                                    >
                                        <Search className="!w-full !h-full !block" />
                                    </button>

                                    <input type="text"
                                        className={`border-none !m-[0] h-[44px] lg:px-[60px] sm:px-[50px] px-[30px] outline-none py-[10px] xl:pr-[35px] sm:pr-[30px] pr-[20px] 2xl:text-[17px] xl:text-[15px] text-[13px] text-black placeholder-black w-[100%] bg-[#f2f2f2]`}
                                        placeholder="What can we help you find?"
                                        onChange={(e) => {
                                            setSearchText(e.target.value);
                                            if (!e.target.value) {
                                                console.log(e.target.value, 'e.target.value')
                                                _getPorductAccordingSection(selectedCategory, 0, "");
                                            }
                                        }}
                                        value={searchText}
                                    />

                                    <button
                                        type="submit"
                                        className="px-[20px] py-[9px] bg-[#000000] text-white border-[1px] border-[#000000] hover:bg-[transparent] hover:text-black"
                                        onClick={() => {
                                            console.log(searchText, 'searchTextsearchTextsearchTextsearchText')
                                            if (searchText) {
                                                _getPorductAccordingSection(selectedCategory, 0, searchText);
                                            }
                                        }}
                                    >Search</button>
                                </div>
                            </div>

                            <div className="w-full text-center">
                                {loading ? (
                                    <CircularProgress className='' />)
                                    :
                                    (
                                        <div className='w-full my-0 mx-auto grid xl:grid-cols-3 sm:grid-cols-2 gap-[15px]'>

                                            {
                                                (allProductState?.length > 0) ?
                                                    _.map(allProductState, ({ points, id, image, title, price, stock, out_of_stock, category_id, ...row }, index) => (
                                                        <div
                                                            key={"Allproduct" + index}
                                                            className="rounded-[0px] bg-[#fff] p-[7px] flex flex-col hover:shadow-[8px_8px_32px_16px_rgba(238,238,238,1)]"
                                                        >
                                                            {/* <div
                                                                className="border border-[#e1e1e1] xl:h-[213px] h-[200px] mb-[15px] flex items-center justify-center cursor-pointer"
                                                                onClick={() => {
                                                                    if (section === "distributor") {
                                                                        setProductOpen({ image, title, price, ...row })
                                                                    } else {
                                                                        allData?.router.push(`/${storeAssigned()}/products/${id}/${_.lowerCase(title)?.replaceAll(/ /g, "_").replaceAll('/', '_')}`)
                                                                    }
                                                                }}
                                                            >
                                                                {(image)
                                                                    ?
                                                                    <img src={image} className="w-full h-full object-contain" alt="product" />
                                                                    :
                                                                    <Image src={notFoundImage} alt="Image 10" className="w-full h-full object-contain" />
                                                                }
                                                            </div> */}

                                                            <div
                                                                className="border border-[#e1e1e1] xl:h-[213px] h-[200px] mb-[15px] flex items-center justify-center cursor-pointer"
                                                                onClick={() => {
                                                                    if (pathname.includes('autoship_edit')) {
                                                                        console.log("Autoship edit detected, add specific logic here if needed");
                                                                    } else if (section === "distributor") {
                                                                        setProductOpen({ image, title, price, ...row });
                                                                    } else {
                                                                        router.push(`/${storeAssigned()}/products/${id}/${_.lowerCase(title)?.replaceAll(/ /g, "_").replaceAll('/', '_')}`);
                                                                    }
                                                                }}
                                                            >
                                                                {(image) ? (
                                                                    <img src={image} className="w-full h-full object-contain" alt="product" />
                                                                ) : (
                                                                    <Image src={notFoundImage} alt="Image 10" className="w-full h-full object-contain" />
                                                                )}
                                                            </div>

                                                            <div className="btn_autoship flex flex-col flex-1">
                                                                <div className="w-full">
                                                                    <h3 className="futura_font text-black text-medium xl:text-[18px] md:text-[16px] tracking-[3px] text-start uppercase leading-[1.30] hover:cursor-pointer hover:text-[#444444]">
                                                                        {title}
                                                                    </h3>
                                                                </div>

                                                                <div className="btn-group w-full text-center">
                                                                    {isLearnMore &&
                                                                        <ButtonComponent link={`${id}/${_.lowerCase(title)?.replaceAll(/ /g, "_").replaceAll('/', '_')}`} text="Learn More" />
                                                                    }
                                                                    {(() => {
                                                                        let oneTimePrice = row[section + '_oneTime'] || price;
                                                                        return (
                                                                            <>
                                                                                {!out_of_stock ?
                                                                                    <>
                                                                                        {onetime &&
                                                                                            <div className={cn(`block w-full text-start text-[#444] xl:text-[20px] sm:text-[18px] text-[16px] font-semibold leading-[1.18] mt-2 transtion-all duration-300 ease-in-out`, 'oneTime')}
                                                                                            >
                                                                                                {getCurrencySign(_.upperCase(storeAssigned()))}{FloatValues(oneTimePrice)}
                                                                                            </div>
                                                                                        }

                                                                                    </>
                                                                                    :
                                                                                    <button type="button"
                                                                                        className={cn(`verify-bg
                                                                                block w-full border-[1px] border-color rounded-[0px] py-[2px] 
                                                                                pt-[12px] pb-[10px] px-[10px] text-black 2xl:text-[26px] xl:text-[20px] sm:text-[20px] 
                                                                                cursor-auto text-[18px] font-normal leading-[1] mb-2 transtion-all 
                                                                                duration-300 mb-0`)}
                                                                                    >
                                                                                        <p>Out Of Stock</p>

                                                                                    </button>}

                                                                                {pathname.includes("autoship_edit") && (
                                                                                    <ButtonComponent
                                                                                        classes={"xl:mb-0 lg:mb-0  mb-0 rounded-[0px] py-[7.5px] px-[20px] max-w-[196px] mx-auto block"}
                                                                                        type="button"
                                                                                        onClick={() => {
                                                                                            if (process.env.NEXT_PUBLIC_COMING_SOON !== 'true') {
                                                                                                _handleProductAdd({ id: id, itemCode: row?.itemCode });
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        {process.env.NEXT_PUBLIC_COMING_SOON === 'true' ? (
                                                                                            <p>Coming Soon</p>
                                                                                        ) : (
                                                                                            <p className='text-[14px] leading-[1.93]'>Add To Cart</p>
                                                                                        )}
                                                                                    </ButtonComponent>
                                                                                )}
                                                                            </>
                                                                        )
                                                                    })()}
                                                                </div>
                                                            </div>
                                                            <DistributorSingleProductPopUp {...{ productOpen, setProductOpen }} />
                                                        </div>
                                                    ))
                                                    :
                                                    <div className="flex justify-center items-center w-full text-[18px] col-span-full">No product Found</div>
                                            }
                                        </div>
                                    )}
                            </div>
                            <div className='w-full'>
                                {
                                    (allProductState?.length > 0) &&
                                    <ReactpaginateComp sortOrder={sortOrder} currentPage={offset} pageCount={totalCount} handlePageClick={(e) => {
                                        _onPaginationChange(e)
                                    }} />
                                }
                            </div>
                        </div>
                    </div>

                </div>
                {(typeof (activeStep) !== 'string') && (
                    <div className='w-full mt-6 justify-center flex gap-x-[20px] ' id="next-button">
                        {(cartProducts?.length > 0) &&
                            <ButtonComponent id="go_next" onClick={() => setActiveStep(activeStep + 1)} classes="w-auto block text-[18px] leading-[1.1] font-normal"> Checkout </ButtonComponent>
                        }
                        {(cartProducts?.length === 0) &&
                            <ButtonComponent id="go_next" onClick={() => setActiveStep(activeStep + 1)} classes=" w-auto block text-[18px] leading-[1.1] font-normal"> Continue without purchase </ButtonComponent>
                        }
                    </div>
                )}
            </div>

        </>
    )
}
export default withProductHOC(AllProductPageComp, 'normal');